export default __webpack_public_path__ + "static/media/helm-of-heroes.477f6a71.jpeg";